import api from "../api";
export default {
    namespaced: true,
    state: {
        system_config_param: {},
        system_config_param_by_code: {},
        error_system_config_param_values: '',
        cards: []
    },
    getters: {

    },
    actions: {
        async get_system_config_by_code({ commit }, payload) {
            try {
                api.post("/v1/system-config-param-values-by-code", payload)
                    .then((res) => {
                        commit("LIST_CONFIG_PARAM_BY_CODE", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_CONFIG_PARAM_VALUES", "Algo deu errado ao listar os ERPS.");
                    })
                    .finally(() => (
                        console.log('login request end')
                    ));
            } catch (e) {

                commit("ERROR_ERPS", "Algo deu errado, entre em contato com os desenvolvedores");
            }
        },
        async get_system_config_param_values({ commit }, id) {
            try {
                api.get("/v1/system-config-params/" + id)
                    .then((res) => {
                        if (res.data) {
                            commit("LIST_CONFIG_PARAM_VALUES", res.data);
                        }
                    })
                    .catch((error) => {
                        console.log("error", error)
                        commit("ERROR_CONFIG_PARAM_VALUES", "Algo deu errado ao listar os ERPS.");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('erps request finally')
                    ));
            } catch (e) {

                commit("ERROR_ERPS", "Algo deu errado, entre em contato com os desenvolvedores");
            }
        },
        async createErp({ commit }, payload) {
            try {
                
                api.post("/v1/system-config-param-values-custom", payload)
                    .then((res) => {
                        commit("LIST_CONFIG_PARAM_BY_CODE", res.data);
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_LOGIN", e);
            }
        }
    },
    mutations: {
        LIST_ERPS(state, data) {
            state.erps.push(...data.erps)
            console.log(state.erps);
        },
        ERROR_ERPS(state, data) {
            console.log(data, 'error')
            state.error_erp = data
        },
        LIST_CONFIG_PARAM_VALUES(state, data) {
            state.system_config_param = data
        },
        LIST_CONFIG_PARAM_BY_CODE(state, data) {
            state.system_config_param_by_code = data
        },
        ERROR_CONFIG_PARAM_VALUES(state, data) {
            console.log(data)
        },
        addCard(state, card) {
            state.cards.push(card);
        },
        CREATE_ERP(state, data){
            
        }

    },

}